import styled from 'styled-components';
import { colors } from '../../theme';
import type { SocialMediaSize } from './SocialMedia.types';
import { SOCIAL_MEDIA_SIZES } from './SocialMedia.constants';

interface StyledSocialMediaLinkProps {
  $size: SocialMediaSize;
}

const getSizeConfig = (size: SocialMediaSize) => SOCIAL_MEDIA_SIZES[size];

export const StyledSocialMediaLink = styled.a<StyledSocialMediaLinkProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => getSizeConfig($size).iconSize};
  height: ${({ $size }) => getSizeConfig($size).iconSize};
  background: ${colors.black};
  border: ${({ $size }) => getSizeConfig($size).borderWidth} solid ${colors.primary};
  border-radius: ${({ $size }) => getSizeConfig($size).borderRadius};
  padding: 0;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: ${colors.primaryTransparent[15]};
    border-color: ${colors.primary};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${colors.primaryTransparent[30]};
  }

  &:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const StyledSocialMediaIcon = styled.img<StyledSocialMediaLinkProps>`
  width: calc(${({ $size }) => getSizeConfig($size).iconSize} - 12px);
  height: calc(${({ $size }) => getSizeConfig($size).iconSize} - 12px);
  object-fit: contain;
  display: block;
`;
